import { useCallback, useEffect, useMemo, useState } from 'react'
import { P2Button } from 'react-bootstrap-common-script'
import { Dropdown } from '../../components/dropdown';
import { DropdownItemInterface } from '../../models/interfaces/dropdown-item.interface';
import data from "../../../src/utils/shared/dummy.json";
import { authenticateUserByNRIC, authenticateUserBySingpassToken, getSpcpName, resetAuthData, updateExpiredIn, updateSingpassToken } from '../../redux/slices/authentication-slice';
import { useAppDispatch } from '../../redux/hook';
import config from '../../config';
import moment from 'moment';
import useCheckTokenExpiry from '../../hooks/use-check-token-expiry';
import { LottieLoader } from '../../components/loader';
import { PolymerAxios } from '../../utils/axios';

let demoMyinfos: DropdownItemInterface[] = data.singpassMyInfo;

function NormalApiLogin() {

  const isProd = useMemo(()=>{
    console.log("process.env.NODE_ENV",process.env.NODE_ENV);
    if (process.env.NODE_ENV !== "production" || document.location.origin === "https://services3-dev.hdb.gov.sg" || document.location.origin === "https://services3-stg.hdb.gov.sg") {
      return false;
    }
    else{
      return true;
    }
  },[])

  // useCheckTokenExpiry();

  const [nric, setNric] = useState<string>("");
  const queryParameters = new URLSearchParams(window.location.search)
  const singpass_code = queryParameters.get("code");
  const expires_in = queryParameters.get("expires_in");
  const AppDispatch = useAppDispatch();

  const [ isProcess, setIsProcess ] = useState<boolean>(false);

  

  const nricSelection = useCallback((e: any) => {
    setNric(e);
  }, [setNric])

  const isSingpassUser = useMemo(()=>{
    return demoMyinfos.find(e=>e.value === nric && e.hide === false)?.code;
  },[nric])

  //Authenticate Login
  const authenticateLogin = useCallback(async () => {
    if( !isSingpassUser ){
      AppDispatch(updateSingpassToken(config.byPassSingpassToken));
      AppDispatch(updateExpiredIn(moment().add(30, "minutes").unix()));
      AppDispatch(authenticateUserByNRIC({ uinfin:nric }));
    }
    else{
      window.location.href = `${config.singpassLoginUrl}`;
      return null;
    }
  }, [AppDispatch, isSingpassUser, nric])

  const resetLogin = useCallback(()=>{
    setIsProcess(false);
    AppDispatch(resetAuthData());

    if(isProd){
      window.location.href = `${config.singpassLoginUrl}`;
    }
  },[AppDispatch, isProd])

  useEffect(()=>{
    if(isProd){
      if(singpass_code && expires_in){
        // has singpass code,
        // validate by another use effect
        // do nothing
      }
      else{
        window.location.href = `${config.singpassLoginUrl}`;
      }
    }
    else{
      //do nothing
    }

  },[expires_in, isProd, singpass_code])


  //WHEN CODE AND EXPIRY RETURN TO THIS PAGE, WE WILL AUTHENTICATED IS TRUE
  useEffect(()=>{
    if(singpass_code && expires_in){
      setIsProcess(true);
    }
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      if(singpass_code && expires_in){
        AppDispatch(authenticateUserBySingpassToken({ singpass_code })).then(res => {
          console.log("authenticateUserBySingpassToken",singpass_code, res);
          console.log("expires_in: ",(Number(expires_in))/1000);
          if (res.type === "authenticateUserBySingpassToken/fulfilled") {
            AppDispatch(updateSingpassToken(singpass_code ?? ""));
            AppDispatch(updateExpiredIn((Number(expires_in))/1000));
            // AppDispatch(updateExpiredIn(moment().add(Number(expires_in), 'milliseconds').unix()));
          }
          else {
            resetLogin();
          }
        }).catch(e => {
          resetLogin();
        });

        AppDispatch(getSpcpName({singpass_code})).then(res => {
          console.log("getSpcpName res: ",res);
        });
      }
      else{
        resetLogin();
      }
    }, 200);
    return () => {
      clearTimeout(timeoutId);
    }
  },[AppDispatch, expires_in, resetLogin, singpass_code]);

  if(isProcess){
    return <>
      <LottieLoader/>
    </>
  }

  if(isProd){
    return <>
      <LottieLoader/>
    </>
  }

  return (
    <main className='container' style={{ padding: 100, display: "flex", flexDirection: "column", marginBottom: '70px' }}>
      <h1>Normal Login Page</h1>
      <Dropdown required selectedDropdown={nric} placeholder='Please select' label={`Please select a user`} variant='small' items={demoMyinfos.filter(e=>!e.hide)} setSelectedDropdown={nricSelection} />
      <P2Button style={{ margin: "20px auto" }} onClick={authenticateLogin} variant={"outline-primary"}>Login</P2Button>
    </main>
  )
}

export default NormalApiLogin


